export { default } from "./ReportDetailLink";
export * from "./ReportDetailLink";
